import { useCallback, useMemo } from 'react';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { ACADEMY_EXERCISE_CONTEXT_KEY } from 'navigation-components/config';
const ContextStoreDefaultState = {
  context: null
};
const RunningStoreDefaultState = {
  isRunning: false
};
const useExerciseContextStore = create()(persist(set => Object.assign({}, ContextStoreDefaultState, {
  setContext: context => set({
    context
  })
}), {
  name: ACADEMY_EXERCISE_CONTEXT_KEY,
  storage: createJSONStorage(() => localStorage)
}));
const useExerciseRunningStore = create()(persist(set => Object.assign({}, RunningStoreDefaultState, {
  setIsRunning: isRunning => set({
    isRunning
  })
}), {
  name: 'academy:practical-exercise-running',
  storage: createJSONStorage(() => sessionStorage)
}));
export const usePracticalExerciseStore = () => {
  const {
    context,
    setContext
  } = useExerciseContextStore();
  const {
    isRunning,
    setIsRunning
  } = useExerciseRunningStore();
  const startExerciseContext = useCallback(ctx => {
    setContext(ctx);
    setIsRunning(true);
  }, [setContext, setIsRunning]);
  const stopExerciseContext = useCallback(() => {
    setContext(null);
    setIsRunning(false);
  }, [setContext, setIsRunning]);
  const resumeExerciseContext = useCallback(() => setIsRunning(true), [setIsRunning]);
  const status = useMemo(() => isRunning && context !== null ? 'RUNNING' : context === null ? 'STOPPED' : 'SUSPENDED', [isRunning, context]);
  return {
    context,
    status,
    startExerciseContext,
    stopExerciseContext,
    resumeExerciseContext
  };
};
export const resetExerciseContextStore = () => useExerciseContextStore.setState(ContextStoreDefaultState);
export const resetExerciseRunningStore = () => useExerciseRunningStore.setState(RunningStoreDefaultState);